/* global DetectUserAgent */
import { browserName as detectedBrowserName, deviceType, osName } from "react-device-detect";

export { deviceType, osName };

export const browserName =
  typeof DetectUserAgent !== "undefined" && DetectUserAgent.isTikTokBrowser() ? "TikTok" : detectedBrowserName;
